export const GET_NOTIFICATION_URL = "https://api.pkh.vn/medpro/noti/getall";

export const GET_NOTIFICATION_ON_PAGE =
  "notifications/GET_NOTIFICATION_ON_PAGE";
export const CHECK_READ_NOTI = "notifications/CHECK_READ_NOTI";

export const GET_NOTIFICATION = "notifications/GET_NOTIFICATION";
export const GET_NOTIFICATION_SUCCESS =
  "notifications/GET_NOTIFICATION_SUCCESS";
export const GET_NOTIFICATION_FAIL = "notifications/GET_NOTIFICATION_FAIL";

export const GET_MORE_NOTIFICATION = "notifications/GET_MORE_NOTIFICATION";
export const GET_MORE_NOTIFICATION_SUCCESS =
  "notifications/GET_MORE_NOTIFICATION_SUCCESS";
export const GET_MORE_NOTIFICATION_FAIL =
  "notifications/GET_MORE_NOTIFICATION_FAIL";

export const UPDATE_READ_NOTIFICATION_URL =
  "https://api.pkh.vn/medpro/noti/update";
export const UPDATE_READ_NOTIFICATION =
  "notifications/UPDATE_READ_NOTIFICATION";

export const DELETE_ALL_NOTIFICATION_URL =
  "https://api.pkh.vn/medpro/noti/delete";
export const DELETE_ALL_NOTIFICATION = "notifications/DELETE_ALL_NOTIFICATION";
export const DELETE_NOTIFICATION = "notifications/DELETE_NOTIFICATION";
export const CLEAR_NOTIFICATION_AT_STORE =
  "notifications/CLEAR_NOTIFICATION_AT_STORE";

export const MARK_ALL_NOTI_AS_READ = "notifications/MARK_ALL_NOTI_AS_READ";

export const GET_NOTIFICATION_BY_TYPE_SUCCESS =
  "notifications/GET_NOTIFICATION_BY_TYPE_SUCCESS";
export const GET_NOTIFICATION_BY_TYPE_FAIL =
  "notifications/GET_NOTIFICATION_BY_TYPE_FAIL";

export const TYPE = "1,2,3,4,5";
export const LIMIT = 15;
export const NUMBER_ON_PAGE = 10;
